import * as types from '../constants/almataConstants';

// Get Almata Partners
export const getAlmataPartners = (params) => ({
  type: types.GET_ALMATA_PARTNERS_REQUEST,
  payload: params,
});

export const getAlmataPartnersSuccess = (data) => ({
  type: types.GET_ALMATA_PARTNERS_SUCCESS,
  payload: data,
});

export const getAlmataPartnersFailure = (error) => ({
  type: types.GET_ALMATA_PARTNERS_FAILURE,
  payload: error,
});

// Add Almata Partner
export const addAlmataPartner = (partnerData) => ({
  type: types.ADD_ALMATA_PARTNER_REQUEST,
  payload: partnerData,
});

export const addAlmataPartnerSuccess = (data) => ({
  type: types.ADD_ALMATA_PARTNER_SUCCESS,
  payload: data,
});

export const addAlmataPartnerFailure = (error) => ({
  type: types.ADD_ALMATA_PARTNER_FAILURE,
  payload: error,
});

// Edit Almata Partner
export const editAlmataPartner = (partnerData) => ({
  type: types.EDIT_ALMATA_PARTNER_REQUEST,
  payload: partnerData,
});

export const editAlmataPartnerSuccess = (data) => ({
  type: types.EDIT_ALMATA_PARTNER_SUCCESS,
  payload: data,
});

export const editAlmataPartnerFailure = (error) => ({
  type: types.EDIT_ALMATA_PARTNER_FAILURE,
  payload: error,
});

// Delete Almata Partner
export const deleteAlmataPartner = (params) => ({
  type: types.DELETE_ALMATA_PARTNER_REQUEST,
  payload: params,
});

export const deleteAlmataPartnerSuccess = (data) => ({
  type: types.DELETE_ALMATA_PARTNER_SUCCESS,
  payload: data,
});

export const deleteAlmataPartnerFailure = (error) => ({
  type: types.DELETE_ALMATA_PARTNER_FAILURE,
  payload: error,
});

// Change Almata Status
export const changeAlmataStatus = (params) => ({
  type: types.CHANGE_ALMATA_STATUS_REQUEST,
  payload: params,
});

export const changeAlmataStatusSuccess = (data) => ({
  type: types.CHANGE_ALMATA_STATUS_SUCCESS,
  payload: data,
});

export const changeAlmataStatusFailure = (error) => ({
  type: types.CHANGE_ALMATA_STATUS_FAILURE,
  payload: error,
});

// Get Scan Types (reusing from OEM)
export const getScanTypes = () => ({
  type: types.GET_ALMATA_SCAN_TYPES_REQUEST,
});

export const getScanTypesSuccess = (data) => ({
  type: types.GET_ALMATA_SCAN_TYPES_SUCCESS,
  payload: data,
});

export const getScanTypesFailure = (error) => ({
  type: types.GET_ALMATA_SCAN_TYPES_FAILURE,
  payload: error,
});

// Get OEM Partners
export const getOemPartners = (params) => ({
  type: types.GET_OEM_PARTNERS_REQUEST,
  payload: params,
});

export const getOemPartnersSuccess = (data) => ({
  type: types.GET_OEM_PARTNERS_SUCCESS,
  payload: data,
});

export const getOemPartnersFailure = (error) => ({
  type: types.GET_OEM_PARTNERS_FAILURE,
  payload: error,
});

// Get OEM Partner Users
export const getOemPartnerUsers = (params) => ({
  type: types.GET_OEM_PARTNER_USERS_REQUEST,
  payload: params,
});

export const getOemPartnerUsersSuccess = (data) => ({
  type: types.GET_OEM_PARTNER_USERS_SUCCESS,
  payload: data,
});

export const getOemPartnerUsersFailure = (error) => ({
  type: types.GET_OEM_PARTNER_USERS_FAILURE,
  payload: error,
});

// Clear actions
export const clearAlmataSuccess = () => ({
  type: types.CLEAR_ALMATA_SUCCESS,
});

export const clearAlmataError = () => ({
  type: types.CLEAR_ALMATA_ERROR,
});

// Reset Almata Password
export const resetAlmataPassword = (params) => ({
  type: types.RESET_ALMATA_PASSWORD_REQUEST,
  payload: params,
});

export const resetAlmataPasswordSuccess = (data) => ({
  type: types.RESET_ALMATA_PASSWORD_SUCCESS,
  payload: data,
});

export const resetAlmataPasswordFailure = (error) => ({
  type: types.RESET_ALMATA_PASSWORD_FAILURE,
  payload: error,
});

export const resendAlmataVerificationEmail = (almataId) => ({
  type: types.RESEND_ALMATA_VERIFICATION_EMAIL_REQUEST,
  payload: almataId,
});

export const resendAlmataVerificationEmailSuccess = (data) => ({
  type: types.RESEND_ALMATA_VERIFICATION_EMAIL_SUCCESS,
  payload: data,
});

export const resendAlmataVerificationEmailFailure = (error) => ({
  type: types.RESEND_ALMATA_VERIFICATION_EMAIL_FAILURE,
  payload: error,
});